import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Grid from '@material-ui/core/Grid';
import Select from '../Select';
import TextField from '../TextField';
import TimePicker from '../TimePicker';
import isDefined from '@afosto/utils/isDefined';
import timeStringToDate from '@afosto/utils/date/timeStringToDate';
import translations from './translations';

const DATE_TYPE_OPTIONS = ['minutes', 'hours', 'days', 'weeks', 'months'];

const fillTimeValue = value => (value < 10 ? `0${value}` : value);

const RelativeDateFields = ({
  margin,
  onChange,
  register: shouldRegister,
  relativeDate,
  showAdvanced,
  showTime,
}) => {
  const intl = useIntl();
  const time = timeStringToDate(
    `${fillTimeValue(relativeDate?.at?.hour ?? 0)}:${fillTimeValue(relativeDate?.at?.minute ?? 0)}`,
  );
  let quantity = relativeDate?.quantity;

  if (isDefined(quantity) && relativeDate?.direction === 'ago') {
    quantity = relativeDate?.quantity * -1;
  }

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <TextField
            name="quantity"
            label={intl.formatMessage(translations.fields.quantity.label)}
            type="number"
            value={quantity ?? ''}
            onChange={onChange('quantity')}
            margin={margin}
            register={shouldRegister}
          />
        </Grid>
        <Grid item xs={8}>
          <Select
            name="key"
            label={intl.formatMessage(translations.fields.type.label)}
            value={relativeDate?.key}
            onChange={onChange('key')}
            suggestions={DATE_TYPE_OPTIONS.reduce(
              (acc, type) => [
                ...acc,
                {
                  value: type,
                  label: intl.formatMessage(translations.dateTypeOptions[type]),
                },
              ],
              [],
            )}
            margin={margin}
            register={shouldRegister}
          />
        </Grid>
      </Grid>
      {showAdvanced && (
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <TextField
              name="dayOfWeek"
              label={intl.formatMessage(translations.fields.dayOfWeek.label)}
              type="number"
              value={relativeDate?.at?.day_of_week ?? ''}
              onChange={onChange('day_of_week')}
              margin={margin}
              register={shouldRegister}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              name="dayOfMonth"
              label={intl.formatMessage(translations.fields.dayOfMonth.label)}
              type="number"
              value={relativeDate?.at?.day_of_month ?? ''}
              onChange={onChange('day_of_month')}
              margin={margin}
              register={shouldRegister}
            />
          </Grid>
          {showTime && (
            <Grid item xs={4}>
              <TimePicker
                name="time"
                label={intl.formatMessage(translations.fields.time.label)}
                value={time}
                onChange={date => onChange('time')({}, date)}
                margin={margin}
                shouldRegister={shouldRegister}
              />
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
};

RelativeDateFields.propTypes = {
  margin: PropTypes.string,
  onChange: PropTypes.func,
  register: PropTypes.bool,
  relativeDate: PropTypes.object,
  showAdvanced: PropTypes.bool,
  showTime: PropTypes.bool,
};

RelativeDateFields.defaultProps = {
  margin: 'normal',
  onChange: undefined,
  register: true,
  relativeDate: {},
  showAdvanced: true,
  showTime: true,
};

export default RelativeDateFields;
